import { createFileRoute } from '@tanstack/react-router';
import { MaintenanceError } from '@/features/errors/maintenance-error';

export const Route = createFileRoute('/(errors)/503')({
    head: () => ({ meta: [{ title: 'Service unavailable | promote.fun' }] }),
    component: MaintenanceError,
});
